export{default}from'./clamp';